export const TEXTS = {
    TITLE: "Remove item from cart",
    DESCRIPTION:
        "This item has multiple customizations added. You would need to remove the item from cart",
    CANCEL: "CANCEL",
    VIEW_CART: "VIEW CART",
};

export const STYLED_CONSTANTS = {
    BUTTON_SIZE: "large" as const,
};
